/* Provides video player state (which YouTube video is open). Simple state-only — no media element needed. */

import { useCallback, useMemo, useState } from "react";
import { VideoPlayerContext, type VideoPlayerContextValue } from "@/contexts/videoPlayerContextValue";
import type { VideoTrack, VideoPlayerState } from "@/types/videoPlayer";

const INITIAL_STATE: VideoPlayerState = { track: null };

export function VideoPlayerProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<VideoPlayerState>(INITIAL_STATE);

  const open = useCallback((track: VideoTrack) => {
    setState({ track });
  }, []);

  const close = useCallback(() => {
    setState(INITIAL_STATE);
  }, []);

  const value = useMemo<VideoPlayerContextValue>(
    () => ({ state, open, close }),
    [state, open, close],
  );

  return (
    <VideoPlayerContext.Provider value={value}>
      {children}
    </VideoPlayerContext.Provider>
  );
}
